import styled, { css } from 'styled-components';
import { Sizes } from 'styles/constants';

import { Colors } from 'styles/enums';
import { mediaQueries } from 'styles/helpers';

export const CardSectionWrapper = styled.div`
  max-width: ${Sizes.maxWidth}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;
export const CardSectionContainer = styled.div`
  height: auto;
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 0px 10px;
  gap: 20px;
  justify-content: space-around;
  flex-wrap: wrap;
  ${mediaQueries(
    'md',
    css`
      padding: 0px 20px;
    `
  )}
`;

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 2rem;
  justify-content: space-between;

  a {
    display: none;
  }
  ${mediaQueries(
    'lg',
    css`
      a {
        display: flex;
      }
    `
  )}

  ${mediaQueries(
    'md',
    css`
      a {
        display: flex;
      }
    `
  )}
`;

export const Sidebar = styled.div`
  height: auto;
  row-gap: 40px;
  flex-direction: column;
  padding: 20px 20px;

  ${mediaQueries(
    'lg',
    css`
      display: flex;
    `
  )}
`;

export const Heading = styled.div`
  height: auto;
  display: flex;
  row-gap: 20px;
  max-width: 100%;
  flex-direction: column;
  text-align: flex-start;
  padding: 20px 20px;
`;

export const ContentPostContainer = styled.div`
  height: auto;
  display: flex;
  flex-direction: row;
  min-height: 20rem;
  width: 100%;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
  width: 90%;

  ${mediaQueries(
    'sm',
    css`
      width: 60%;
    `
  )}

  ${mediaQueries(
    'md',
    css`
      width: 100%;
    `
  )}
`;

const getDisplay = ($isPeopleCard: boolean) => {
  return css`
    ${mediaQueries(
      'md',
      css`
        display: ${$isPeopleCard ? 'none' : 'flex'};
      `
    )}
    ${mediaQueries(
      'lg',
      css`
        display: ${$isPeopleCard ? 'none' : 'flex'};
      `
    )}
  `;
};

export const DisplayTitleWrapper = styled.div<{ $isPeopleCard: boolean }>`
  display: flex;
  ${({ $isPeopleCard }) => getDisplay($isPeopleCard)}
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 1rem;
`;

export const PaginationItem = styled.button<{ $selected: boolean }>`
  border: none;
  background-color: transparent;
  color: ${Colors.Primary.base100};
  font-weight: bold;
  cursor: pointer;
  padding: 1px;
  border-bottom: 2px solid;
  border-color: ${({ $selected }) => ($selected ? `${Colors.Yellow.base100}` : 'transparent')};
`;
